import React, { Fragment, useState } from 'react';
import { FormHelperText, IconButton, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import ClearIcon from '@mui/icons-material/Clear';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import clsx from 'clsx';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

export const useStyles = makeStyles()((theme) => ({
  input: {
    fontWeight: 600,
  },
  disabled: {
    backgroundColor: '#ededed',
    color: '#8d8d8d',
  },
  typography: {
    color: '#707070',
    marginBottom: '5px',
  },
}));

function AxlDateTimePicker(props) {
  const { classes } = useStyles();
  const { label, value, disabled, handleDeleteDate, format, error, helperText, placeholder, ...otherProps } = props;
  const [open, setOpen] = useState(false);

  return (
    <Fragment>
      {label && <Typography className={classes.typography}>{label}</Typography>}
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DateTimePicker
          value={value}
          className={clsx(disabled && classes.disabled)}
          fullWidth
          slotProps={{
            textField: {
              size: props.size || 'small',
              onClick: () => {
                if (!disabled) setOpen(true);
              },
              InputProps: {
                className: classes.input,
                readOnly: true,
                startAdornment: value && (
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteDate(e);
                    }}
                    style={{ order: 1, padding: 0 }}
                    size="large"
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                ),
              },
              InputAdornmentProps: {
                position: 'end',
                style: { order: 2, marginLeft: 0 },
              },
            },
          }}
          disabled={disabled}
          open={open}
          onOpen={() => {
            if (!disabled) setOpen(true);
          }}
          onClose={() => setOpen(false)}
          format={format || 'YYYY/MM/DD HH:mm'}
          {...otherProps}
          label={placeholder}
        />
      </LocalizationProvider>
      {error && (
        <FormHelperText error={error} style={{ marginLeft: 14 }}>
          {helperText}
        </FormHelperText>
      )}
    </Fragment>
  );
}

export default AxlDateTimePicker;
